module.exports = __webpack_public_path__ + "img/send.b19c248c.svg";